module.exports = __webpack_public_path__ + "media/icons/wlasciciel-firma-blue@3x-51d36178.svg";